import { API_BASE_URL } from "../config";
import generateAvatarUrl from "../app/utils/generateAvatarUrl";

export function resolveAssetUrl(raw) {
  if (!raw || typeof raw !== "string") return null;
  const u = raw.trim();
  if (!u) return null;
  if (u.startsWith("http://") || u.startsWith("https://")) return u;
  const base = String(API_BASE_URL || "").replace(/\/$/, "");
  return u.startsWith("/") ? `${base}${u}` : `${base}/${u}`;
}

/** Catalog search item or persisted market.subject */
export function catalogItemToSubjectPayload(item) {
  if (!item?.entityId) return null;
  const type = String(item.type || item.entityType || "").toLowerCase();
  const entityType =
    type === "team" ? "TEAM" : type === "player" ? "PLAYER" : type === "league" ? "LEAGUE" : null;
  if (!entityType) return null;
  return { entityType, entityId: item.entityId };
}

export function subjectFromMarket(market) {
  const s = market?.subject;
  if (!s?.imageUrl) return null;
  return {
    entityType: s.entityType,
    entityId: s.entityId ? String(s.entityId) : null,
    name: s.name || "",
    logo: resolveAssetUrl(s.imageUrl),
    imageUrl: s.imageUrl,
  };
}

export function subjectFromContractLine(line) {
  const s = line?.subject;
  if (!s?.imageUrl) return null;
  return {
    entityType: s.entityType,
    entityId: s.entityId ? String(s.entityId) : null,
    name: s.name || "",
    logo: resolveAssetUrl(s.imageUrl),
    imageUrl: s.imageUrl,
  };
}

/**
 * Hero image for a market card (binary / multi parent).
 * @param {object} market
 * @param {string} [fallbackLabel]
 */
export function getMarketHeroImageUrl(market, fallbackLabel = "Market") {
  const fromSubject = subjectFromMarket(market)?.logo;
  if (fromSubject) return fromSubject;
  const label = market?.subject?.name?.trim() || fallbackLabel;
  return generateAvatarUrl(label);
}

/**
 * Outcome line image for MULTI_BINARY.
 */
export function getContractLineImageUrl(line, fallbackLabel) {
  const fromSubject = subjectFromContractLine(line)?.logo;
  if (fromSubject) return fromSubject;
  const label = line?.subject?.name?.trim() || fallbackLabel || line?.label || "Outcome";
  return generateAvatarUrl(label);
}

export function findContractLineByKey(market, selectionKey) {
  if (!selectionKey || !Array.isArray(market?.contractLines)) return null;
  return (
    market.contractLines.find((l) => String(l?.selectionKey) === String(selectionKey)) ||
    null
  );
}
